<div class="main">

    <div class="title">Vehicle info:</div>

    <div class="inputs">
        <div class="input-field">
            <input type="text" pInputText [(ngModel)]="poManager.current.vehicleMake">
            <span>{{VI.removeUnderscores(VI.makeText)}} {{makeOptional ? '(optional)' : ''}}</span>
        </div>

        <div class="input-field">
            <input type="text" pInputText [(ngModel)]="poManager.current.vehicleModel">
            <span>{{VI.removeUnderscores(VI.modelText)}} {{modelOptional ? '(optional)' : ''}}</span>
        </div>

        <div class="input-field">
            <input type="text" pInputText [(ngModel)]="poManager.current.vehicleColor">
            <span>{{VI.removeUnderscores(VI.colorText)}} {{colorOptional ? '(optional)' : ''}}</span>
        </div>

        <div class="input-field" *ngIf="numberStateVisible">
            <input type="text" pInputText [(ngModel)]="poManager.current.vehicleNumber">
            <span>{{VI.removeUnderscores(VI.numberText)}} {{numberOptional ? '(optional)' : ''}}</span>
        </div>

        <div class="input-field" *ngIf="numberStateVisible">
            <input type="text" pInputText [(ngModel)]="poManager.current.vehicleState">
            <span>{{VI.removeUnderscores(VI.stateText)}} {{stateOptional ? '(optional)' : ''}}</span>
        </div>
    </div>
</div>